import gql from 'graphql-tag';
import {
  fieldsToGqlString,
} from '../../../util/shared/vue-global';
import { clients } from '../../../util/clients';
import { MortgageCompanyPaymentsData, lockBox } from '../../../components/shared/Utils/mtgCoProcessing.utils';

const { backend } = clients.direct;

const defaultBillRequest = {
  _id: '',
  taxYear: '',
  taxId: '',
  taxIdFromTaxRoll: '',
  mtgCompany: '',
  nameFromMtgComp: '',
  ownerName: '',
  propertyOrParcelId: '',
  mtgCode: '',
};

const defaultmortgageFileds = {
  totalRecords: '',
  matches: '',
  errors: '',
  recordsWithMtgCode: '',
};

export const MortgageCoProcessing = {
  namespaced: true,
  state: () => ({
    isDialog: false,
    selectedMortgageCompanyPaymentsItems: [],
    mortgageCompanyMapperItems: {},
    pipeline: {},
    totalResults: {},
    getCountRecords: 0,
  }),
  mutations: {
    setDialog(state, isDialog) {
      state.isDialog = isDialog;
    },
    setMortgageCompanyPaymentsItems(state, items) {
      state.selectedMortgageCompanyPaymentsItems = items;
    },
    setMortgageCompanyMapperItems(state, items) {
      state.mortgageCompanyMapperItems = items;
    },
    setPipeline(state, items) {
      state.pipeline = items;
    },
    setTotalResults(state, items) {
      state.totalResults = items;
    },
    setRecordCount(state, item) {
      state.getCountRecords = item;
    },
  },
  getters: {
    getDialog(state) {
      return state.isDialog;
    },
  },
  actions: {
    loadMortgageCompanyPaymentsRecords({ commit }, { baseCrudKey }) {
      const response = MortgageCompanyPaymentsData;
      const withPostProcess = [...response];
      commit('base/crud/setItems', [baseCrudKey, withPostProcess], { root: true });
    },
    async loadMtgBillRequestsRecords({ commit, dispatch },
      { baseCrudKey, criteria, postProcessTrans }) {
      let results;
      try {
        const gqlfields = defaultBillRequest;
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`
            query taxMortgageCoProcessing($criteria: taxMortgageCoProcessingCriteriaType) {
              taxMortgageCoProcessing(criteria: $criteria) {
                ${fieldsToGqlString(gqlfields)},
              }
            }
          `,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        if (results.data) {
          const { taxMortgageCoProcessing } = results.data;
          const processedData = postProcessTrans
            ? postProcessTrans(taxMortgageCoProcessing) : taxMortgageCoProcessing;
          commit('base/crud/setItems', [baseCrudKey, processedData], { root: true });
        }
      } catch (e) {
        dispatch('logException', e, { root: true });
        clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting Bill Request list.', { root: true });
      }
    },
    loadLockBoxRecords({ commit }, { baseCrudKey }) {
      const response = lockBox;
      const withPostProcess = [...response];
      commit('base/crud/setItems', [baseCrudKey, withPostProcess], { root: true });
    },
    async loadResultsCounts({ commit, dispatch }) {
      let results;
      try {
        const gqlfields = defaultmortgageFileds;
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`
            query mortageCodeResult {
              mortageCodeResult {
                ${fieldsToGqlString(gqlfields)},
              }
            }
          `,
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        if (results.data) {
          const { mortageCodeResult } = results.data;
          commit('setRecordCount', mortageCodeResult.matches);
          commit('setTotalResults', mortageCodeResult);
        }
      } catch (e) {
        dispatch('logException', e, { root: true });
        clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting Bill Request list.', { root: true });
      }
    },
    async getResultsCount({ commit, dispatch }, { criteria }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`
            query getMortgageResultsCounts($criteria: taxMortgageCoProcessingCriteriaType) {
              getMortgageResultsCounts(criteria: $criteria) {
                totalRecords,
              }
            }
          `,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);

        if (results.data) {
          const { getMortgageResultsCounts } = results.data;
          commit('setRecordCount', getMortgageResultsCounts.totalRecords);
        }
      } catch (e) {
        dispatch('logException', e, { root: true });
        clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting count of result.', { root: true });
      }
    },
    async updateMTGCode({ commit, dispatch }, { upsert }) {
      let results;
      try {
        results = await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation updateMortgageCodes ($upsert: taxMortgageCoProcessingCriteriaType)  {
            updateMortgageCodes(upsert: $upsert) {
              statusCode,
            }
          }`,
          variables: {
            upsert,
          },
        });
        clients.handleGQLErrors(results, commit);
        if (results) {
          const { updateMortgageCodes } = results.data;
          return updateMortgageCodes || {};
        }
      } catch (e) {
        dispatch('logException', e, { root: true });
        clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting count of result.', { root: true });
      }
      return {};
    },
    async clearMortgageCodes({ commit, dispatch }, { upsert, confirmClearAll }) {
      let results;
      try {
        results = await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation clearMortgageCodes (
            $upsert: taxMortgageCoProcessingCriteriaType,
            $confirmClearAll: Boolean,
          )  {
            clearMortgageCodes(upsert: $upsert, confirmClearAll: $confirmClearAll) {
             statusCode,
            }
          }`,
          variables: {
            upsert,
            confirmClearAll,
          },
        });
        clients.handleGQLErrors(results, commit);
        const { clearMortgageCodes } = results.data;
        return clearMortgageCodes || {};
      } catch (e) {
        dispatch('logException', e, { root: true });
        clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting count of result.', { root: true });
      }
      return {};
    },
    async updateRecordValidationStatus({ commit, dispatch }, {
      fileQueueId, recordIndex, validationStatus,
    }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation updateRecordValidationStatus(
            $fileQueueId: ID!
            $recordIndex: Int!
            $validationStatus: String!
          ) {
            updateRecordValidationStatus(
              fileQueueId: $fileQueueId
              recordIndex: $recordIndex
              validationStatus: $validationStatus
            ) {
              success
              message
            }
          }`,
          variables: {
            fileQueueId,
            recordIndex,
            validationStatus,
          },
        });
        clients.handleGQLErrors(results, commit);
        if (results && results.data && results.data.updateRecordValidationStatus) {
          return results.data.updateRecordValidationStatus;
        }
        return { success: false, message: 'No response from server' };
      } catch (e) {
        dispatch('logException', e, { root: true });
        clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem updating record status.', { root: true });
        return { success: false, message: e.message };
      }
    },
  },
};

export default MortgageCoProcessing;
